"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class RCSequencerManager {
  constructor() {
    _defineProperty(this, "maxSequenceLength", 14);
    this.sequence = [];
    this.nextMovement = null;
    this.currentlyRunningMovement = null;
    this.isSequencerOn = true;
  }
  isSequenceFull() {
    return this.sequence.length > this.maxSequenceLength;
  }
  addToSequence(movement) {
    let forceAdd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (this.isSequenceFull()) return;
    // if we are in controller mode, we don't want to add a new movement if there is already one running
    if (!this.isSequencerOn && this.currentlyRunningMovement && !forceAdd) return;
    if (this.sequence.length === 0 || this.currentlyRunningMovement && this.isThisTheLastMovementInTheSequence(this.currentlyRunningMovement)) {
      // if the incoming movement is the first,
      // or if the currently running movement is the last movement,
      // then add the incoming movement as a next movement
      this.nextMovement = movement;
    }
    this.sequence.push(movement);
    // if sequencer is NOT on and is NOT currently executing, execute first movement
    if (!this.isSequencerOn && this.sequence.length === 1) {
      this.executeNext();
    } else {
      this.updateComponent();
    }
  }
  isThisMovementRunning(movement) {
    return this.currentlyRunningMovement === movement;
  }
  pauseExecution() {
    var _this$currentlyRunnin;
    (_this$currentlyRunnin = this.currentlyRunningMovement) === null || _this$currentlyRunnin === void 0 || _this$currentlyRunnin.destroyTimeout();
    this.currentlyRunningMovement = null;
    this.nextMovement = null;
    this.updateComponent();
  }
  clearSequence() {
    var _this$currentlyRunnin2;
    this.sequence = [];
    (_this$currentlyRunnin2 = this.currentlyRunningMovement) === null || _this$currentlyRunnin2 === void 0 || _this$currentlyRunnin2.destroyTimeout();
    this.currentlyRunningMovement = null;
    this.nextMovement = null;
    this.updateComponent();
  }
  removeFromSequence() {
    this.sequence.pop();
    this.updateComponent();
  }
  removeFromSequenceByIdx(idx) {
    if (this.currentlyRunningMovement) return;
    this.sequence.splice(idx, 1);
    this.updateComponent();
  }
  shiftFromSequence() {
    this.sequence.shift();
  }
  isThisTheLastMovementInTheSequence(movement) {
    return this.sequence.findIndex(mv => mv === movement) === this.sequence.length - 1;
  }
  getNextMovementAfterThisOne(movement) {
    const movementIdx = this.sequence.findIndex(mv => mv === movement);
    return this.sequence[movementIdx + 1] || null;
  }
  resetAndPrepareSequence() {
    if (this.sequence.length) this.nextMovement = this.sequence[0];
  }
  executeNext() {
    // set currently running movement,
    // execute next movement,
    // set next movement
    if (this.currentlyRunningMovement) {
      // if there was a running movement, shift if from the sequence
      !this.isSequencerOn && this.shiftFromSequence(); // remove previously running movement
      this.currentlyRunningMovement = null; // making sure we set to null here, in case there is no next movement running later
    }

    // if there is next movement make the appropriate preparations
    if (this.nextMovement) {
      this.nextMovement.execute(this.executeNext.bind(this));
      // order matters here
      this.currentlyRunningMovement = this.nextMovement; // set currently running movement
      // set new nextMovement
      this.nextMovement = this.getNextMovementAfterThisOne(this.nextMovement);
    }
    this.updateComponent();
  }
  updateComponent() {
    this.componentUpdater(oldState => oldState + 1);
  }
  setComponentUpdater(componentUpdater) {
    this.componentUpdater = componentUpdater;
  }
}
const sequenceManager = new RCSequencerManager();
var _default = exports.default = sequenceManager;